<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="
        !isEdit ? $t('traffic.maintain.add') : $t('traffic.maintain.edit')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="form"
        :rules="rulesCenter"
        :model="formInfo"
        label-suffix="："
        :label-position="'right'"
        :label-width="'auto'"
      >
        <el-form-item :label="$t('traffic.licensePlate')" prop="licensePlate">
          <el-input
            v-model="formInfo.licensePlate"
            :placeholder="$t('traffic.licensePlate')"
            @focus="selectCarVisible = true"
          />
        </el-form-item>
        <el-form-item :label="$t('traffic.maintain.mileage')" prop="mileage">
          <el-input
            v-model="formInfo.mileage"
            clearable
            :placeholder="$t('traffic.maintain.mileage')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('traffic.maintain.handleTime')"
          prop="handleTime"
        >
          <el-date-picker
            v-model="formInfo.handleTime"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            :placeholder="$t('traffic.maintain.handleTime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('traffic.maintain.itemIdList')"
          prop="itemIdList"
        >
          <template v-if="maintainCardList.length">
            <el-card
              v-for="(type, i) in maintainCardList"
              :key="i"
              class="card-container"
            >
              <div slot="header">
                <span>{{ $t(`traffic.maintain.${type.type}`) }}</span>
              </div>
              <el-checkbox-group v-model="formInfo.itemIdList">
                <el-checkbox
                  :label="item.itemId"
                  v-for="(item, index) in type.data"
                  :key="index"
                  border
                >
                  {{ item.itemName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-card>
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('traffic.maintain.nextRemind')"
          prop="nextRemind"
        >
          <el-radio-group v-model="formInfo.nextRemind">
            <el-radio :label="1">
              {{ $t('traffic.maintain.tx') }}
            </el-radio>
            <el-radio :label="0">
              {{ $t('traffic.maintain.btx') }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 下次保养开始 -->
        <el-form-item
          :label="$t('traffic.maintain.nextMileage')"
          prop="nextMileage"
        >
          <el-input
            v-model="formInfo.nextMileage"
            clearable
            :placeholder="$t('traffic.maintain.nextMileage')"
          />
        </el-form-item>
        <el-form-item :label="$t('traffic.maintain.nextTime')" prop="nextTime">
          <el-date-picker
            v-model="formInfo.nextTime"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            :placeholder="$t('traffic.maintain.nextTime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('traffic.maintain.nextItems')"
          prop="nextItems"
        >
          <template v-if="maintainCardList.length">
            <el-card
              v-for="(type, i) in maintainCardList"
              :key="i"
              class="card-container"
            >
              <div slot="header">
                <span>{{ $t(`traffic.maintain.${type.type}`) }}</span>
              </div>
              <el-checkbox-group v-model="formInfo.nextItemIdList">
                <el-checkbox
                  :label="item.itemId"
                  v-for="(item, index) in type.data"
                  :key="index"
                  border
                >
                  {{ item.itemName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-card>
          </template>
        </el-form-item>
        <!-- 下次保养结束 -->
        <el-form-item :label="$t('traffic.remark')" prop="remark">
          <el-input
            v-model="formInfo.remark"
            :rows="3"
            :autosize="{ minRows: 3, maxRows: 3 }"
            resize="none"
            :placeholder="$t('traffic.remark')"
            type="textarea"
            :maxlength="500"
            :show-word-limit="true"
          />
        </el-form-item>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="closeDialog"
        >{{ $t("public.cancel") }}</el-button
      >
      <el-button v-waves type="primary" @click="handleSubmit">
        {{ $t("public.define") }}
      </el-button>
    </span>

    <select-car-dialog
      :visibles.sync="selectCarVisible"
      @select-complete="selectComplete"
    />
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// 组件
import SelectCarDialog from './selectCarDialog'
// request
import { maintainAddUrl, maintainEditUrl, maintainItemListUrl } from '@/api/traffic'
import resolve from '@/api/resolve'
export default {
  name: 'AddUpdateDialog',
  components: { SelectCarDialog },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validateLicensePlate = (rule, value, cb) => {
      if (!this.formInfo.licensePlate) return cb(new Error(this.$t('traffic.errorLicensePlate')))
    }
    const validateMileage = (rule, value, cb) => {
      if (!this.formInfo.mileage || !(/^(0|[1-9]\d*)(\.\d*[0-9])?$/.test(this.formInfo.mileage))) return cb(new Error(this.$t('traffic.errorMileage')))
    }
    const validateNextMileage = (rule, value, cb) => {
      if (!this.formInfo.nextMileage || !(/^(0|[1-9]\d*)(\.\d*[0-9])?$/.test(this.formInfo.nextMileage))) return cb(new Error(this.$t('traffic.errorMileage')))
    }
    const validateHandleTime = (rule, value, cb) => {
      if (!this.formInfo.handleTime) return cb(new Error(this.$t('traffic.errorTime')))
    }
    const validateItemIdList = (rule, value, cb) => {
      if (!this.formInfo.itemIdList.length) return cb(new Error(this.$t('traffic.maintain.errorMaintain')))
    }
    const validateNextTime = (rule, value, cb) => {
      if (!this.formInfo.nextTime) return cb(new Error(this.$t('traffic.errorTime')))
    }
    const validateNextItems = (rule, value, cb) => {
      if (!this.formInfo.nextItemIdList.length) return cb(new Error(this.$t('traffic.maintain.errornext')))
    }
    
    return {
      formInfo: {},
      rulesCenter: {
        licensePlate: [
          { required: true, trigger: ['blur', 'change'], validator: validateLicensePlate }
        ],
        mileage: [
          { required: true, trigger: ['blur', 'change'], validator: validateMileage }
        ],
        nextMileage: [
          { required: true, trigger: ['blur', 'change'], validator: validateNextMileage }
        ],
        nextTime: [
          { required: true, trigger: ['blur', 'change'], validator: validateNextTime }
        ],
        nextItems: [
          { required: true, trigger: ['blur', 'change'], validator: validateNextItems }
        ],
        handleTime: [
          { required: true, trigger: ['blur', 'change'], validator: validateHandleTime }
        ],
        itemIdList: [
          { required: true, trigger: ['blur', 'change'], validator: validateItemIdList }
        ]
      },
      maintainType: ['basicMaintain', 'deepMaintain', 'cleanMaintain', 'customized'],
      maintainCardList: [],
      selectCarVisible: false,
    }
  },
  created() {
    this._fetchMaintainList()
  },
  watch: {
    visibles(v) {
      if (v && this.isEdit) {
        let itemIdList = [], nextItemIdList = []
        this.data.items.forEach((v, i) => {
          itemIdList[i] = v.itemId
        })
        this.data.nextItems.forEach((v, i) => {
          nextItemIdList[i] = v.itemId
        })
        this.formInfo = { itemIdList, nextItemIdList, ...this.data }
      }
      if (v && !this.isEdit) {
        this.formInfo = { itemIdList: [], nextItemIdList: [], ...this.data }
      }
    }
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 提交
    handleSubmit() {
      let formList = []
      if(this.formInfo.nextRemind == 1){
        formList = ['licensePlate', 'mileage', 'handleTime', 'itemIdList', 'nextTime', 'nextMileage','nextItems']
      }else{
        formList = ['licensePlate', 'mileage', 'handleTime', 'itemIdList']
      }
      const formCheck = this.checkForm({
        formName: 'form',
        formList: formList
      })
      if (!formCheck) return
      const { carId, mileage, handleTime, itemIdList, nextTime, nextMileage, nextItemIdList, remark, nextRemind } = this.formInfo
      const postData = {
        nextItems: nextItemIdList,
        carId,
        mileage,
        handleTime,
        itemIdList,
        nextTime,
        nextMileage,
        remark,
        nextRemind
      }
      if (!this.isEdit) {
        this._createMaintain(postData)
      } else {
        this._updateMaintain(postData)
      }
    },
    // 新增
    _createMaintain(postData) {
      this.$http.post(maintainAddUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateMaintain(postData) {
      this.$http.put(resolve(maintainEditUrl, this.formInfo.maintainId), postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    // 获取保养项目
    _fetchMaintainList() {
      this.$http.get(maintainItemListUrl).then(({ data }) => {
        if (data.code === 0) {
          this.maintainType.forEach((v, i) => {
            this.maintainCardList[i] = {
              type: this.maintainType[i],
              data: data.data.filter(item => item.itemType === i + 1)
            }
          })
        }
      })
    },
    // 选择车辆完成
    selectComplete(id, plate) {
      this.formInfo.carId = id
      this.formInfo.licensePlate = plate
    }
  }
}
</script>

<style lang="scss">
.card-container {
  .el-card__body {
    padding: 5px 14px;
  }
  .el-card__header {
    padding: 0 20px;
  }
  .el-checkbox {
    margin: 5px;
  }
  .el-checkbox__input {
    display: none;
  }
  .el-checkbox {
    &.is-bordered {
      &.is-checked {
        border-color: #409eff;
        background-color: #409eff;
      }
    }
  }
  .el-checkbox-group {
    .is-checked {
      .el-checkbox__label {
        color: white;
      }
    }
  }
}
</style>
